import { Box, Text } from '@chakra-ui/react';

import { flights, instant } from './format';
import { ApplySummary } from './payload';

type Props = {
  applied: ApplySummary | null;
};

/**
 * The one-line record of what an apply wrote. The flights themselves are already in the table above (tagged
 * "Fills blank leg"), so this only states that — and when — they were written.
 */
export const AppliedSummary = ({ applied }: Props) => {
  if (!applied) return null;

  return (
    <Box borderWidth="1px" borderRadius="md" p="3">
      <Text fontSize="sm" fontWeight="medium">
        {applied.isAuto ? 'Applied automatically' : 'Applied'}
        {applied.appliedAt ? ` on ${instant(applied.appliedAt)}` : ''} — {flights(applied.filled.length)} filled onto
        the quote
      </Text>
    </Box>
  );
};
